
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { LoanAutopayConfirmInput } from '@/loan/types/loan-autopay-confirm-input';
import { ModalState } from '@/core/types/modal-state';

@Component
export default class LoanAutopayConfirmModal extends Vue {
	@Prop({ required: true })
	public current!: LoanAutopayConfirmInput | null;

	public isShown = false;

	@Prop({ required: true })
	public previous!: LoanAutopayConfirmInput | null;

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	get currentDraftText(): string {
		return this.current?.draftText ?? '';
	}

	get previousDraftText(): string {
		return this.previous?.draftText ?? '';
	}

	public close(): void {
		this.isShown = false;
	}

	@Emit('confirm')
	public emitConfirm(): boolean {
		this.close();
		return true;
	}

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}
}
